var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"d-flex align-items-center",attrs:{"size":"sm","variant":"secondary","data-test":"download-pdf"},on:{"click":function($event){return _vm.print()}}},[_vm._v("\n  Download Creatives as PDF\n")])}
var staticRenderFns = []

export { render, staticRenderFns }